import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { handleScheduleTicketClick } from '../../actions/general.actions';
import { withRouter } from 'react-router';
import iconTickets from '../../../FO/resources/img/icon-tickets.png';
import arrowUp from '../../../FO/resources/img/schedule-arrow-up.png';
import arrowDown from '../../../FO/resources/img/schedule-arrow-down.png';
import { slugify } from "../../helpers/general.helper";
import { storeSelectedCinemaLocation, storeSelectedHour } from '../../actions/filters.actions';
import { LOGIN_ROUTE } from '../../config/routes';

class CarouselItemSchedule extends Component {

    constructor(props) {
        super(props);
        this.state = {
            showDropDown: false,
            updateIsSelectedHour: false,
            selectedHour: '',
            event_id: '',
            schedule_id: ''
        }
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.selectedDate !== nextProps.selectedDate) {
            this.setState({ selectedHour: '' });
        }
        if (nextProps.showDropDown) {
            this.setState({
                showDropDown: false
            });
        }
    }

    // Method is user when hours dropdown values are changed
    handleHourChange(hour) {
        this.setState({
            selectedHour: hour.schedule_broadcast_hour,
            event_id: hour.schedule_event_id,
            schedule_id: hour.schedule_id
        });
    }

    // Method is used when user click on ticket icon
    buyTicket(schedule, cinema_locality) {

        if (localStorage.getItem('login_type') === 'authenticated'){
            this.props.storeSelectedCinemaLocation(cinema_locality);
            const payload = {
                projectionFormat: schedule.schedule_projection_format,
                hour: this.state.selectedHour || schedule.schedule_broadcast_hours[0].schedule_broadcast_hour,
                eventId: this.state.event_id || schedule.schedule_broadcast_hours[0].schedule_event_id,
                scheduleId: this.state.schedule_id || schedule.schedule_broadcast_hours[0].schedule_id,
                userId: localStorage.getItem("user_id"),
                film_url: `/film/${schedule.film.film_id}/${slugify(schedule.film.film_title)}`,
            }
            this.props.handleScheduleTicketClick(payload);
            this.props.storeSelectedHour(payload);
        } else {
            this.props.history.push(LOGIN_ROUTE);
        }
    }

    // Color background color of hour
    selectHour(hour) {
        hour.isSelected = true;
        this.setState({
            updateIsSelectedHour: hour.isSelected
        });
    }

    // Uncolor background color of hour
    unSelectHour(hour) {
        hour.isSelected = false;
        this.setState({
            updateIsSelectedHour: hour.isSelected
        });
    }

    // Show/Hide dropdows
    toggleDropDown() {
        // Delay this function beacause of saga dispatch to happend
        // Global event it`s on div for closing the dropdown
        let _self = this;
        let isOpen = this.state.showDropDown;
        isOpen = !isOpen;
        setTimeout(function () {
            _self.setState({
                showDropDown: isOpen
            });
        }, 100);

    }

    // Return a div element for displaying dropdown items
    mapHoursInSelect(schedule, i) {
        return <div className={`hour-item ${schedule.isSelected === true ? 'selected' : ''}`} onClick={() => this.handleHourChange(schedule)}
            key={i} onMouseOver={() => this.selectHour(schedule)} onMouseLeave={() => this.unSelectHour(schedule)}>
            <div className="projection-format">{this.props.card.schedule_projection_format}</div>
            <div className="schedule-dubbed-subtitled">{this.props.card.schedule_dubbed_subtitled === 'Dublat' ? 'Dub' : 'Sub'}</div>
            <div className="hour">{schedule.schedule_broadcast_hour}</div>
            <div className="arrow"></div>
        </div>
    }

    goTo(url) {
        window.open(url, '_blank');
    }

    getConditionalButton = () => {
        if (this.props.cinema) {
            if (this.props.cinema.cinema_ticket_sales === 1) {
                return <img src={iconTickets} onClick={() => this.buyTicket(this.props.card, this.props.cinema.cinema_address_locality)} alt={'Ticket'} />
            } else {
                return <img src={iconTickets} onClick={() => this.goTo(this.props.cinema.cinema_website)} alt={'Ticket'} />
            }
        }
    };

    render() {
        return (
            <Fragment>
                <div className="movie-details col-10 .col-md-8 col-lg-9 no-gutters">
                    <div className="select-hours" id="dropdown" onMouseDown={() => this.toggleDropDown()}>
                        <div className="projection-format">{this.props.card.schedule_projection_format}</div>
                        <div className="schedule-dubbed-subtitled">{this.props.card.schedule_dubbed_subtitled === 'Dublat' ? 'Dub' : 'Sub'}</div>
                        <div className="hour">{this.state.selectedHour.length > 0 ? this.state.selectedHour : this.props.card.schedule_broadcast_hours[0].schedule_broadcast_hour}</div>
                        <div className="arrow">{this.state.showDropDown === true ? <img className="arrowIcon" src={arrowUp} alt={'Arrow'} /> : <img className="arrowIcon" src={arrowDown} alt={'Arrow'} />}</div>
                    </div>
                    <div className={`projection-format-content ${this.state.showDropDown === true ? 'show' : ''}`} >
                        {this.props.card.schedule_broadcast_hours.map((schedule, i) => this.mapHoursInSelect(schedule, i), this)}
                    </div>
                </div>
                <div className="icon col-2 .col-md-4 col-lg-3 no-gutters" >
                    {this.getConditionalButton()}
                </div>
            </Fragment>
        );
    }
}

const mapStateToProps = state => ({
    showDropDown: state.errors.showDropDown,
    selectedDate: state.filters.reservetionSelectedDate
});

export default withRouter(connect(mapStateToProps, { handleScheduleTicketClick, storeSelectedCinemaLocation, storeSelectedHour })(CarouselItemSchedule));


// WEBPACK FOOTER //
// ./src/SHARED/components/carousel/carouselitemschedule.component.js